export default __webpack_public_path__ + "static/media/TTNormsPro-Bold.e1c69876.woff2";